import { motion, AnimatePresence } from "framer-motion";
import ScrollAnimation from "../../hooks/ScrollAnimation";
import AttorneyCard from "../section/AttorneyCard";

const SkeletonCard = () => (
    <div className="h-full rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
        <div className="animate-pulse space-y-4">
            <div className="h-5 w-2/3 rounded-full bg-gray-200" />
            <div className="h-4 w-5/6 rounded-full bg-gray-200" />
            <div className="h-16 rounded-xl bg-gray-100" />
            <div className="h-10 rounded-full bg-gray-100" />
        </div>
    </div>
);

const AttorneyList = ({ attorneys, loading, onOpenTicket, currentPage, totalPages, onPageChange }) => {
    if (loading) {
        return (
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                {Array.from({ length: 8 }).map((_, i) => <SkeletonCard key={i} />)}
            </div>
        );
    }

    if (attorneys.length === 0) {
        return (
            <div className="rounded-3xl border border-dashed border-blue-200 bg-blue-50/60 p-10 text-center">
                <h3 className="text-xl font-semibold text-blue-700">No attorneys found</h3>
                <p className="mt-2 text-sm text-blue-600">Try adjusting your filters.</p>
            </div>
        );
    }

    return (
        <>
            <motion.div layout className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                <AnimatePresence>
                    {attorneys.map((attorney, i) => (
                        <ScrollAnimation key={attorney.id} direction="up" delay={i * 0.05}>
                            <AttorneyCard
                                attorney={attorney}
                                onOpenTicket={onOpenTicket} // يمرر الدالة
                            />
                        </ScrollAnimation>
                    ))}
                </AnimatePresence>
            </motion.div>

            {totalPages > 1 && (
                <div className="mt-10 flex items-center justify-between rounded-full border border-gray-200 bg-white px-4 py-3 text-sm shadow-sm">
                    <button
                        onClick={() => onPageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="inline-flex items-center rounded-full border border-blue-200 bg-blue-50 px-4 py-2 font-semibold text-blue-600 hover:bg-blue-100 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Previous
                    </button>
                    <span className="text-gray-600">
                        Page <span className="font-semibold text-blue-600">{currentPage}</span> of {totalPages}
                    </span>
                    <button
                        onClick={() => onPageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="inline-flex items-center rounded-full border border-blue-200 bg-blue-50 px-4 py-2 font-semibold text-blue-600 hover:bg-blue-100 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Next
                    </button>
                </div>
            )}
        </>
    );
};

export default AttorneyList;